namespace advisorop.components.common {


    export class NewWorkflowInstanceController {
        workflowMaster: domains.IWorkflowMaster;
        iAmReady: any;
        onWorkflowInstanceCreate: any;
        modelDirty: boolean = false;

        model: domains.IWorkflowInstance = {
            id: 0,
        };

        creatingWorkflowInstanceLadda: boolean = false;

        static $inject = ["servicerService", "generalService", "identityService", "workflowApi"];
        constructor(private servicerService: services.ServicerService,
            private generalService: services.GeneralService,
            private identityService: services.IdentityService,
            private workflowApi: services.WorkflowApi) {
        }

        onModelChange(): void {
            this.modelDirty = true;
        }

        save(): void {
            this.model.id = 0;
            this.creatingWorkflowInstanceLadda = true;

            this.workflowApi.createWorkflowInstance(this.model).
                then(data => {
                    toastr.success("Workflow instance successfully created.");

                    // call back to the popup controller to store this instance in a list
                    if (this.onWorkflowInstanceCreate)
                        this.onWorkflowInstanceCreate(this.model);

                    // reinit model so that another instance can be created in the same popup
                    this.model = new domains.IWorkflowInstance();
                    this.model.id = 0;
                    this.model.workflowMasterId = this.workflowMaster.id;

                }).
                catch(err => {
                    toastr.error("Unable to create workflow:", err);
                });
        }

        $onInit(): void {

            //console.log("CuProposal: onInit fired");
            this.model.workflowMasterId = this.workflowMaster.id;
            if (this.iAmReady)
                this.iAmReady({ ctrl: this });
        }

        $routerOnActivate(next, previous) {
        }

        hhInvSearchCallback(type: string, id: number): void {
            //console.log("In hhInvSearchCallback. Type selected:", type)
            //console.log("In hhInvSearchCallback. Id selected:", id);
            if (type === "household")
                this.model.householdId = id;
            else if (type === "investor")
                this.model.investorId = id;
            this.onModelChange();
        }

        acctSearchCallback(id: number): void {
            //console.log("In acctSearchCallback. AccountId:", id)
            this.model.accountId = id;
            this.onModelChange();
        }
    }


    class NewWorkflowInstance implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;
        transclude: boolean;

        constructor() {
            this.controller = NewWorkflowInstanceController;
            this.controllerAs = "vm";
            this.transclude = true;
            this.bindings = {
                workflowMaster: "<",
                iAmReady: "&",
                onWorkflowInstanceCreate: "&",
            };
            this.templateUrl = "spa/shared/common/new-workflow-instance.html";
        }
    }
    angular.module(Constants.APP).component("newWorkflowInstance", new NewWorkflowInstance());
}